//webkitURL is deprecated but nevertheless
URL = window.URL || window.webkitURL;

let gumStream; 						//stream from getUserMedia()
let rec; 							//Recorder.js object
let input; 							//MediaStreamAudioSourceNode we'll be recording

// shim for AudioContext when it's not avb.
var AudioContext = window.AudioContext || window.webkitAudioContext;
var audioContext //audio context to help us record

var recordButton = document.getElementById("recordButton");
var stopButton = document.getElementById("stopButton");
var removeButton = document.getElementById("removeButton");

var recordLoading = document.getElementById("record-loading");
stopButton.hidden = true;
recordLoading.hidden = true;
removeButton.hidden = true;

//add events to those 2 buttons
recordButton.addEventListener("click", startRecording);
stopButton.addEventListener("click", stopRecording);
removeButton.addEventListener("click", deleteRecord);

function startRecording() {
    console.log("recordButton clicked");

    /*
        Simple constraints object, for more advanced audio features see
        https://addpipe.com/blog/audio-constraints-getusermedia/
    */

    var constraints = { audio: true, video:false };

    /*
       Disable the record button until we get a success or fail from getUserMedia()
   */

    recordButton.hidden = true;
    stopButton.hidden = false;
    recordLoading.hidden = false;

    /*
        We're using the standard promise based getUserMedia()
        https://developer.mozilla.org/en-US/docs/Web/API/MediaDevices/getUserMedia
    */

    navigator.mediaDevices.getUserMedia(constraints).then(function(stream) {
        console.log("getUserMedia() success, stream created, initializing Recorder.js ...abc");

        /*
            create an audio context after getUserMedia is called
            sampleRate might change after getUserMedia is called, like it does on macOS when recording through AirPods
            the sampleRate defaults to the one set in your OS for your playback device

        */
        audioContext = new AudioContext();

        //update the format
        document.getElementById("formats").innerHTML="Format: 1 channel pcm @ "+audioContext.sampleRate/1000+"kHz"

        /*  assign to gumStream for later use  */
        gumStream = stream;

        /* use the stream */
        input = audioContext.createMediaStreamSource(stream);

        /*
            Create the Recorder object and configure to record mono sound (1 channel)
            Recording 2 channels  will double the file size
        */

        rec = new Recorder(input,{ numChannels:1});

        //start the recording process
        rec.record();
        let list = document.getElementById("recordingsList");
        list.innerHTML = '';
        console.log("Recording started");

    }).catch(function(err) {
        //enable the record button if getUserMedia() fails
        recordButton.hidden = false;
        stopButton.hidden = true;
        recordLoading.hidden = true;

    });
}

function stopRecording() {
    console.log("stopButton clicked bbc");

    //disable the stop button, enable the record too allow for new recordings
    recordButton.hidden = true;
    stopButton.hidden = true;
    recordLoading.hidden = true;
    removeButton.hidden = false;


    //tell the recorder to stop the recording
    rec.stop();

    //stop microphone access
    gumStream.getAudioTracks()[0].stop();

    //create the wav blob and pass it on to createDownloadLink
    rec.exportWAV(createDownloadLink);
}

function deleteRecord() {
    console.log("deleteRecord clicked bbc");

    //disable the stop button, enable the record too allow for new recordings
    recordButton.hidden = false;
    stopButton.hidden = true;
    removeButton.hidden = true;

    let list = document.getElementById("recordingsList");
    list.innerHTML = '';
    document.getElementById('audioInput').value = '';
}

const changePitch = (source, semitones) => {
    var cents = semitones * 100;
    source.playbackRate.value = Math.pow(2.0, cents / 1200.0);
};

function anonymizeVoice(blob, callback) {
    // Převést blob na AudioBuffer
    blob.arrayBuffer().then(arrayBuffer => {
        const audioContext = new (window.AudioContext || window.webkitAudioContext)();
        audioContext.decodeAudioData(arrayBuffer).then(audioBuffer => {
            // Nyní, když známe délku audioBufferu, vytvoříme OfflineAudioContext s odpovídající délkou
            const offlineAudioContext = new OfflineAudioContext(
                audioBuffer.numberOfChannels,
                audioBuffer.length * 1.5 + 50000,
                audioBuffer.sampleRate
            );

            const source = offlineAudioContext.createBufferSource();
            source.buffer = audioBuffer;

            // Zde přidáme distortion
            const waveShaper = offlineAudioContext.createWaveShaper();
            waveShaper.curve = makeDistortionCurve(200); // Hodnota 400 je jen příklad, experimentujte s různými hodnotami
            waveShaper.oversample = '4x';

            // Změna pitch zde - příklad snížení o 5 půltónů
            const semitones = -3;
            const cents = semitones * 100;
            source.playbackRate.value = Math.pow(2.0, cents / 1200.0);

            source.connect(waveShaper);
            waveShaper.connect(offlineAudioContext.destination);
            source.start(0); // Start the source playback at the beginning of the buffer

            // Render the audio and export as a Blob
            offlineAudioContext.startRendering().then(renderedBuffer => {
                // Convert the rendered buffer to a Blob
                const wavBlob = bufferToWave(renderedBuffer, renderedBuffer.length);
                callback(wavBlob); // Pass the blob to the callback
            });
        }).catch(e => {
            console.log("Error with decoding audio data", e);
        });
    });
}

function makeDistortionCurve(amount) {
    var k = typeof amount === 'number' ? amount : 50,
        n_samples = 44100,
        curve = new Float32Array(n_samples),
        deg = Math.PI / 180,
        i = 0,
        x;
    for ( ; i < n_samples; ++i ) {
        x = i * 2 / n_samples - 1;
        curve[i] = ( 3 + k ) * x * 20 * deg / ( Math.PI + k * Math.abs(x) );
    }
    return curve;
}

// Pomocná funkce pro převod AudioBuffer na WAV Blob
function bufferToWave(audioBuffer, length) {
    const numOfChan = audioBuffer.numberOfChannels;
    const sampleRate = audioBuffer.sampleRate;
    const format = (numOfChan === 2 ? 1 : 3); // 1 is PCM, 3 is IEEE float
    const bitDepth = (format === 1 ? 16 : 32);

    let bytesPerSample = bitDepth / 8;
    const blockAlign = numOfChan * bytesPerSample;
    const byteRate = sampleRate * blockAlign;
    const waveLength = length * blockAlign + 44;
    const buffer = new ArrayBuffer(waveLength);
    const view = new DataView(buffer);

    let offset = 0;

    writeString(view, offset, 'RIFF'); offset += 4;
    view.setUint32(offset, 36 + length * blockAlign, true); offset += 4;
    writeString(view, offset, 'WAVE'); offset += 4;
    writeString(view, offset, 'fmt '); offset += 4;
    view.setUint32(offset, 16, true); offset += 4; // Subchunk1Size (16 for PCM)
    view.setUint16(offset, format, true); offset += 2; // AudioFormat (1 for PCM, 3 for IEEE float)
    view.setUint16(offset, numOfChan, true); offset += 2; // NumChannels
    view.setUint32(offset, sampleRate, true); offset += 4; // SampleRate
    view.setUint32(offset, byteRate, true); offset += 4; // ByteRate
    view.setUint16(offset, blockAlign, true); offset += 2; // BlockAlign
    view.setUint16(offset, bitDepth, true); offset += 2; // BitsPerSample
    writeString(view, offset, 'data'); offset += 4;
    view.setUint32(offset, length * blockAlign, true); offset += 4; // Subchunk2Size

    // Now write the actual audio data
    for (let i = 0; i < length; i++) {
        for (let channel = 0; channel < numOfChan; channel++) {
            const outputIndex = 44 + i * blockAlign + channel * bytesPerSample;
            if (format === 1) { // PCM
                const sample = Math.max(-1, Math.min(1, audioBuffer.getChannelData(channel)[i]));
                view.setInt16(outputIndex, sample < 0 ? sample * 32768 : sample * 32767, true);
            } else if (format === 3) { // IEEE float
                view.setFloat32(outputIndex, audioBuffer.getChannelData(channel)[i], true);
            }
        }
    }

    return new Blob([view], { type: 'audio/wav' });
}

// Pomocná funkce pro psaní stringů do DataView
function writeString(view, offset, string) {
    for (let i = 0; i < string.length; i++){
        view.setUint8(offset + i, string.charCodeAt(i));
    }
}

function createDownloadLink(blobb) {

    anonymizeVoice(blobb, function(blob) {


        var url = URL.createObjectURL(blob);
        var au = document.createElement('audio');
        var span = document.createElement('span');

        //name of .wav file to use during upload and download (without extendion)
        var filename = new Date().toISOString();

        //add controls to the <audio> element
        au.controls = true;
        au.src = url;

        //add the new audio element to li
        span.appendChild(au);

        span.appendChild(document.createTextNode (" "));//add a space in between
        let list = document.getElementById("recordingsList");
        list.innerHTML = '';
        list.appendChild(span);

        // Vytvoříme soubor z Blobu
        const audioFile = new File([blob], "anonymized.wav", { type: 'audio/wav', lastModified: new Date()});

        // Nastavíme tento soubor jako hodnotu pro input typu file
        const dataTransfer = new DataTransfer();
        dataTransfer.items.add(audioFile);

        const audioInput = document.getElementById('audioInput');
        audioInput.files = dataTransfer.files;
    });

}